import React from "react"
import { WhiteDiv } from "../components/whitediv"
import { Layout } from "../components/baselayout"
import { NewsItem } from "../components/newsitem"
import { TwitterTimelineEmbed } from "react-twitter-embed"
import { Link } from "gatsby"
import { BellBoard } from "../components/bellboardfeed"
const sad = require("../images/news/sad_face.png")

const NewsAndEvents: React.FC = () => (
  <Layout title="Fun News">
    <WhiteDiv>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div style={{ flexBasis: "50%", flexGrow: 1 }}>
          <h1>Fun News!</h1>
          <hr />
          <NewsItem title="No news, SORRY!" image={sad}>
            stella asked me to write a new news article but everything got
            cancelled because of the SCARY VIRUS! HALP!
          </NewsItem>
          <h2>Fun Ringing Events!</h2>
          <hr />
          <p>
            See our full calendar <Link to="/ringwithus">here</Link>.
          </p>
        </div>
        <div style={{ width: "min(20rem,100%)", marginLeft: "1rem" }}>
          <BellBoard numItems={6} />
          <div style={{ border: "1px solid lightgrey" }}>
            <TwitterTimelineEmbed
              sourceType="profile"
              screenName="cugcr"
              options={{ height: "60rem" }}
            />
          </div>
        </div>
      </div>
    </WhiteDiv>
  </Layout>
)

export default NewsAndEvents
